/**
 * A plan limit as the text of an input, and back.
 *
 * The wire says "unlimited" with `-1` (docs/architecture/plan-entitlements-contract.md,
 * "Data model"); an input says it with a blank, whose placeholder reads "Unlimited", so
 * a super admin never has to know the sentinel. A value that is not an integer (a plan
 * with no number stored) also reads as blank: the resolver treats a missing number as
 * unlimited. Shared by the plan matrix and the per-tenant entitlements editor, so the two
 * screens cannot disagree about what a blank cell means.
 */
export const UNLIMITED = -1;

export const limitToText = (v) => (Number.isInteger(v) && v !== UNLIMITED ? String(v) : "");

/** `-1` for blank, the integer for digits (zero included), `null` for anything else. */
export const textToLimit = (s) => {
  const v = String(s ?? "").trim();
  if (v === "") return UNLIMITED;
  return /^\d+$/.test(v) ? Number(v) : null;
};
